import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { DateService } from '@thewhite/react-global-module/lib/services';
import { DateType } from '@thewhite/react-global-module/lib/types';
import * as t from 'io-ts';
import BASE_PROGRESS_STATUS, { BaseProgressStatusEnumType } from '../../Global/enums/baseProgressStatus';
import { BaseEntityNullable, BaseEntityNullableType } from '../../Global/models/baseEntityNullable';
import ParticipantItemsGroup, { ParticipantItemsGroupDto, ParticipantItemsGroupType } from '../../Participant/model/participantItemsGroup';
import EventList, { EventListType } from './eventList';

export const ParticipantType = t.interface({
    id: t.string,
    comment: t.union([t.string, t.null, t.undefined]),
    declineComment: t.union([t.string, t.null, t.undefined]),
    event: EventListType,
    user: BaseEntityNullableType,
    items: t.array(ParticipantItemsGroupType),
    status: BaseProgressStatusEnumType,
    date: t.union([DateType, t.null, t.undefined]),
    startTime: t.union([t.string, t.null, t.undefined]),
    endTime: t.union([t.string, t.null, t.undefined]),
    serviceContractMisId: t.union([t.string, t.null, t.undefined]),
});

export interface ParticipantDto extends t.TypeOf<typeof ParticipantType> {
}

// заявка = участник
class Participant {
    id: string;
    comment: string | null;
    declineComment: string | null;
    event: EventList;
    user: BaseEntityNullable;
    items: ParticipantItemsGroup[];
    status: SimpleObjectInterface;
    date: Date | null;
    startTime: string | null;
    endTime: string | null;
    serviceContractMisId: string | null;

    constructor(params: ParticipantDto) {
        this.id                   = params.id;
        this.comment              = params.comment ?? null;
        this.declineComment       = params.declineComment ?? null;
        this.event                = new EventList(params.event);
        this.user                 = new BaseEntityNullable(params.user);
        this.items                = params.items
            .map((group: ParticipantItemsGroupDto) => new ParticipantItemsGroup(group));
        this.status               = BASE_PROGRESS_STATUS[params.status];
        this.date                 = params.date
            ? DateService.getValidDate(params.date)
            : null;
        this.startTime            = params.startTime ?? null;
        this.endTime              = params.endTime ?? null;
        this.serviceContractMisId = params.serviceContractMisId ?? null;
    }
}

export default Participant;
